import React from 'react';
import PropTypes from 'prop-types';
import { Button } from '@material-ui/core';
import BundleOperationDialog from '../../../../components/kea/BundleOperationDialog';
import { useLocalizedMessage } from '../../../../util/useLocalizedMessage';
import PreviewButton from '../PreviewButton';

export default function BuildOverlay({ open, state, error, onClose, onRetry }) {
  const localizeMessage = useLocalizedMessage();

  const isBuilding = state === 'building';
  const isSuccess = state === 'success';
  const isError = state === 'error';

  let dialogState = 'building';
  let title = localizeMessage('searchInterface.build.title');
  let heading = localizeMessage('searchInterface.build.building');
  let description = localizeMessage('searchInterface.build.buildingHint');
  let detail = null;
  let detailKind = null;

  if (isSuccess) {
    dialogState = 'success';
    title = localizeMessage('operator.bundle.preview.dialog.success.title');
    heading = localizeMessage('searchInterface.build.success');
    description = localizeMessage('searchInterface.build.successHint1');
    detailKind = 'info';
    detail = (
      <p>
        {localizeMessage('searchInterface.build.successHint2')}
        {' '}
        <code>?kea-preview=true</code>
      </p>
    );
  }

  if (isError) {
    dialogState = 'error';
    title = localizeMessage('operator.bundle.preview.dialog.error.title');
    heading = localizeMessage('searchInterface.build.error');
    description = localizeMessage('searchInterface.build.errorHint');
    detailKind = 'error';
    detail = <p>{error || localizeMessage('searchInterface.build.errorHint')}</p>;
  }

  let actions = null;
  if (isSuccess) {
    actions = (
      <>
        <Button variant="outlined" onClick={onClose} data-testid="preview-build-close">
          {localizeMessage('common.close')}
        </Button>
        <PreviewButton variant="contained" color="primary" />
      </>
    );
  }

  if (isError) {
    actions = (
      <>
        <Button variant="outlined" onClick={onClose} data-testid="preview-build-cancel">
          {localizeMessage('common.cancel')}
        </Button>
        <Button
          variant="contained"
          color="primary"
          onClick={onRetry}
          data-testid="preview-build-retry"
        >
          {localizeMessage('searchInterface.build.retry')}
        </Button>
      </>
    );
  }

  return (
    <BundleOperationDialog
      open={open}
      state={dialogState}
      title={title}
      heading={heading}
      description={description}
      detail={detail}
      detailKind={detailKind}
      actions={actions}
      onClose={isBuilding ? null : onClose}
      closeLabel={localizeMessage('common.close')}
      closeTestId="preview-build-dismiss"
      progressLabel={heading}
      testId="preview-build-dialog"
    />
  );
}

BuildOverlay.propTypes = {
  open: PropTypes.bool.isRequired,
  state: PropTypes.oneOf(['building', 'success', 'error']).isRequired,
  error: PropTypes.string,
  onClose: PropTypes.func,
  onRetry: PropTypes.func,
};

BuildOverlay.defaultProps = {
  error: null,
  onClose: null,
  onRetry: null,
};
